module.exports = __webpack_public_path__ + "static/media/415.8ccfecd4.webp";